export default __webpack_public_path__ + "static/06-the-world-large-0c936ce4b199f6e90d1497cd25f5155d.svg";